import React from 'react'

export default class IconLogoGoogleDomains extends React.Component {

    render() {
        let color = "#C8C5FE";
        if (this.props.color) color = this.props.color;
        let className = "icons-icon";

        return <svg className={className} style={this.props.style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="6" fill="white" />
            <g clipPath="url(#clip0_391_40380)">
                <path d="M21.3101 3C21.8049 3 22.1387 3.50526 21.9432 3.9594L14.9703 20.6406C14.7056 21.2511 14.1026 21.6466 13.4365 21.6466H8.67104C8.1763 21.6466 7.83043 21.1579 8.02743 20.7038L8.57329 19.394L9.76427 12.4391L13.2244 8.23308L14.9868 4.00601C15.25 3.39549 15.7432 3 16.4094 3H21.3101Z" fill="#4285F4" />
                <path d="M13.2485 8.17441C12.0365 6.99696 10.3764 6.27967 8.55079 6.29922C4.89365 6.33982 1.95981 9.32929 2.00042 12.9759C2.03951 16.5654 4.94628 19.4526 8.52673 19.5037C8.54327 19.4586 11.7297 14.4571 11.7297 14.4571C11.7297 14.4571 13.2485 8.17741 13.2485 8.17441Z" fill="#FBBC04" />
                <path d="M13.2487 8.17432C13.2487 8.17432 8.52235 19.5051 8.52686 19.5051C8.584 19.5066 8.64115 19.5066 8.69829 19.5051C12.3569 19.4645 15.2893 16.4766 15.2487 12.8285C15.2291 11.0029 14.4652 9.35778 13.2487 8.17432Z" fill="#EA4335" />
            </g>
            <defs>
                <clipPath id="clip0_391_40380">
                    <rect width="20" height="18.6719" fill="white" transform="translate(2 3)" />
                </clipPath>
            </defs>
        </svg>
    }
}    
